import {db} from './index';
import {collection, doc, getDocs, orderBy, query, setDoc, where} from 'firebase/firestore';
import {snapShotToArray} from './common';

const productsCollection = collection(db, 'products');
const productsListCollection = collection(db, 'products-list');

export const getAllProducts = async () => {
  const array = snapShotToArray(await getDocs(query(productsCollection, orderBy('name', 'asc'))));
  // writeToFile('scales.json', array)
  return array.map(value => {
    const {updatedAt, ...other} = value;
    return other;
  });

};

export const getProductsList = async () => snapShotToArray(await getDocs(query(productsListCollection, orderBy('name', 'asc'))));

export const getProductsForCategory = async (categoryUrl) => {
  const array = snapShotToArray(await getDocs(query(productsListCollection, where('categoryUrls', 'array-contains', categoryUrl), orderBy('name', 'asc'))));
  return array.sort((a, b) => a.order - b.order).map(value => {
    const {updatedAt, createdAt, ...other} = value;
    return other;
  });
};

export const getFeaturedProductsList = async () => snapShotToArray(await getDocs(query(productsListCollection, where('featured', '==', true))));

export const getProduct = async (productId) => {
  const array = snapShotToArray(await getDocs(query(productsCollection, where('url', '==', productId)))) || [];
  // writeToFile('scales.json', array)
  return array.map(value => {
    const {updatedAt, ...other} = value;
    return other;
  })[0];
};

export const getProductFromProductList = async (productId) => {
  const array = snapShotToArray(await getDocs(query(productsListCollection, where('url', '==', productId)))) || [];
  // writeToFile('scales.json', array)
  return array.map(value => {
    const {updatedAt, ...other} = value;
    return other;
  })[0];
}

export const addNewProduct = async (scale) => setDoc(doc(db, 'products', scale.id), scale, {merge: true});
